import type { FaireProductEntity } from "../../entity_types/product";

export const p_5aep3berj9: FaireProductEntity = {
  token: "p_5aep3berj9",
  type: "product",
  name: "Autumn Petrichor | BEST SELLER | 8oz Fall Candle",
  brandToken: "b_ymy9myk6jv",
  brandName: "Kandlery",
  imageUrl:
    "https://cdn.faire.com/fastly/c8646c6df4301c1a0bc8b53edc698b859dbe8b6195b8bf8d017d56ba558bc796.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/563f09692f4190691f66ad0c1ecd26ffd87f04109e1a7054e48119db338ac1ae.png",
    "https://cdn.faire.com/fastly/c9d2e9b805233a4f5b407ebd440fa784f5b095c897d6916d3b802d72e26d5561.png",
    "https://cdn.faire.com/fastly/1b4534d9041c1861f65625476d1dbc5b55be8b7e7da6e6df57a334276c366077.jpeg",
    "https://cdn.faire.com/fastly/2af2947635a27e8021c24859bc6281d63fe1389a6338fa1c64fa6632640db487.png",
    "https://cdn.faire.com/fastly/7d310aed01fd89c47b12ab3b694ad4067eb7a76676d6d6d15fe14f19735a2771.png",
    "https://cdn.faire.com/fastly/72e5255aca455d99d200a6fce51a7fc947ff54df49d227ebbb332547f4580231.png",
    "https://cdn.faire.com/fastly/af14a846db58106247a58bcba2edd05d15571f0aa963041fd8ff0a16cd5d8ece.png",
    "https://cdn.faire.com/fastly/89fe398e6fc8bb9c610e55f236f5489070295126f4677eda4b17d9bb4a75b3ec.png",
  ],
  priceDollars: 15,
  description:
    "Immerse yourself in autumn’s magic with Autumn Petrichor, capturing the city’s essence as the season changes.\n\n• Top: Soil, Wet Leaves, and Branches\n• Heart: Autumn Leaves, Petrichor\n• Base: Lavender, Oakmoss, Smoky Incense, and Cedar Leaf\n\n𝐒𝐢𝐳𝐞 𝐨𝐩𝐭𝐢𝐨𝐧𝐬:\n8 oz. wood wicked aura jar with a lid\n\nNon-toxic | cruelty-free | vegan | pet-friendly\n\nProudly 'Made Better Certified'.\nOur goal is to source supplies with the highest quality standards in mind.\n\n𝐖𝐡𝐲 𝐊𝐚𝐧𝐝𝐥𝐞𝐫𝐲?\n• Natural Coconut Wax\n• Crackling Wooden Wick, Made from FSC Certified Wood.\n• Lead free & Self-trimming Cotton Wick\n• Non Toxic Ingredients\n• Premium Soothing Fragrances (Free of phthalate, reproductive toxins, and other concerning chemicals.)\n• Cruelty Free\n• Handcrafted in Small Batch\n• Untapped Asian-inspired scents",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:06.966Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
